const clientBaseurl = "http://localhost:5000";

function saveLoginInfo() {
    let userinfo = JSON.parse(window.bpnativeobj.getUserInfo());
    // alert(JSON.stringify(userinfo))
    sessionStorage.setItem("headimgurl", userinfo.avatar);
    let loginInfo = JSON.parse(window.bpnativeobj.getLoginInfo());
    //alert(JSON.stringify(loginInfo))
    sessionStorage.setItem("sessionid", loginInfo.token);
    //alert(loginInfo.token)
    sessionStorage.setItem("dyflag", loginInfo.dy);
    sessionStorage.setItem("userid", loginInfo.userId);

    let devInfo = JSON.parse(window.bpnativeobj.getsign())
    sessionStorage.setItem("deviceid", devInfo.code);
    sessionStorage.setItem("deviceimei", devInfo.imei);
    sessionStorage.setItem(
        "deviceModel",
        devInfo.deviceModel
    );
}

function StringFormat(source, params) {
    if (arguments.length === 1) {
        return function() {
            var args = $.makeArray(arguments);
            args.unshift(source);
            return $.validator.format.apply(this, args);
        };
    }
    if (arguments.length > 2 && params.constructor !== Array) {
        params = $.makeArray(arguments).slice(1);
    }
    if (params.constructor !== Array) {
        params = [params];
    }
    $.each(params, function(i, n) {
        source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function() {
            return n;
        });
    });
    return source;
}

//获取版本号的第一部分
function getVerCode(fullversion) {
    var arr = fullversion.split(".");
    if ((arr != null) && (arr.length >= 1)) {
        console.log("版本号：" + parseInt(arr[0]));
        return parseInt(arr[0]);
    } else {
        return -1;
    }
}


function getCookie(name) {
    var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

function isEndWith(oriString, endStr) {
    var d = oriString.length - endStr.length;
    return (d >= 0 && oriString.lastIndexOf(endStr) == d);
}

function trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
}

function addGetParam(url) {
    var index = url.indexOf("?");
    var params = "";
    if (index != -1) {
        params = url.substring(index + 1, url.length);
        //alert(params);
    }



    var timestamp = Date.parse(new Date()) / 1000;
    //alert(timestamp);
    var ran = parseInt(1000000 * Math.random()); //shuanimei?timestamp=123&sign=123&r=123")
    var addParams = "&timestamp=" + timestamp + "&r=" + ran;
    //alert(ran);

    var responseText = window.bpnativeobj.requestGetSign(params + addParams);

    // $.ajax({
    //     url: clientBaseurl + "/shuanimei?" + params + addParams,
    //     timeout: 3000,
    //     async: false
    // }).responseText;

    if (responseText == undefined) {
        alert("get签名失败");
        return;
    }

    var json = JSON.parse(responseText);

    addParams = addParams + "&sign=" + json.result;

    if ((json.result + "") == "-1") {
        alert("请关闭网络代理后重启蜜蜂");
    }

    return url + addParams;
};

function addPostParam(params) {
    params.timestamp = Date.parse(new Date()) / 1000;
    //params.sign = "";
    params.r = parseInt(1000000 * Math.random());

    //alert(1)
    var responseText = window.bpnativeobj.requestPostSign(JSON.stringify(params));
    // alert(responseText)
    // $.ajax({
    //     type: "POST",
    //     timeout: 3000,
    //     url: clientBaseurl + "/shuanimei",
    //     data: params,
    //     dataType: "json",
    //     async: false
    // }).responseText;

    if (responseText == undefined) {
        alert("post签名失败");
        // document.location.href = "../index.htm";
        return;
    }

    var json = JSON.parse(responseText);

    //alert(json.result);
    params.sign = json.result;
}

function getDayName(od) {
    var td = new Date();
    td = new Date(td.getFullYear(), td.getMonth(), td.getDate());
    od = new Date(od.replace(/-/g, "/"));
    od = new Date(od.getFullYear(), od.getMonth(), od.getDate());
    var xc = (od - td) / 1000 / 60 / 60 / 24;
    if (xc < -2) {
        return -xc + "天前";
    } else if (xc < -1) {
        return "前天";
    } else if (xc < 0) {
        return "昨天";
    } else if (xc == 0) {
        return "今天";
    } else if (xc < 2) {
        return "明天";
    } else if (xc < 3) {
        return "后天";
    } else {
        return xc + "天后";
    }
}

function hidetaskname(taskname) {
    if (taskname.length == 0) {
        return taskname;
    }
    var hidestr = "";
    for (var i = 1;
        (i < taskname.length) && (i < 4); i++) {
        hidestr = hidestr + "*";
    }
    return taskname[0] + hidestr;
}

function importjs(jsurl) {
    var head = document.head || document.getElementsByTagName('head')[0]
    var script = document.createElement('script')

    script.type = 'text/javascript'
    script.src = jsurl

    if (!('onload' in script)) {
        script.onreadystatechange = function() {
            if (this.readyState !== 'complete' && this.readyState !== 'loaded') return
            this.onreadystatechange = null
        }
    }

    script.onload = function() {
        this.onload = null
    }

    head.appendChild(script)
}

function isAlmostOver(endtime) {
    var delt = endtime - Date.parse(new Date());
    if ((delt > 0) && (delt <= 0.5 * 60 * 60 * 1000)) { //半小时以内将结束的任务
        return true;
    }
    return false;
}

function getQueryString(name) {
    var result = window.location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];
}

function getQueryStringByUrl(url, name) {
    // var result = window.location.search.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    // if (result == null || result.length < 1) {
    //     return "";
    // }
    // return result[1];
}

function HTMLDecode(text) {
    var temp = document.createElement("div");
    temp.innerHTML = text;
    var output = temp.innerText || temp.textContent;
    temp = null;
    return output;
}

function vuealert(vueobj, msg) {
    // vueobj.alert.show({
    //     content: msg,
    //     buttonText: "好的",
    //     hideOnBlur: true
    // });

    alert(msg);
}

function getHostUrl() {
    let isTest = getQueryString("test");
    if (isTest == "true") {
        return "http://beta_api.szgaodashang.com";
    } else {
        return " http://api.naboyi.com";
    }
}


export default {
    clientBaseurl: clientBaseurl,
    downloadUrl: "http://img.szgaodashang.com/apk/app-release.apk",
    hosturl: getHostUrl(),
    getVerCode: getVerCode,
    importjs: importjs,
    getDayName: getDayName,
    getQueryString: getQueryString,
    getQueryStringByUrl: getQueryStringByUrl,
    hidetaskname: hidetaskname,
    isAlmostOver: isAlmostOver,
    getCookie: getCookie,
    addPostParam: addPostParam,
    saveLoginInfo: saveLoginInfo,
    trim: trim,
    StringFormat: StringFormat,
    addGetParam: addGetParam,
    vuealert: vuealert,
    HTMLDecode: HTMLDecode,
    isEndWith: isEndWith,
    arrPhoneType: ["iPhone simulator", "iPhone", "iPhone 3G", "iPhone 3GS", "iPhone 4",
        "iPhone 4S", "iPhone 5", "iPhone 5C", "iPhone 5S", "iPhone 5s"
    ],
    mapPhoneType: {
        "iPhone simulator": 0,
        "iPhone": 5,
        "iPhone 3G": 10,
        "iPhone 3GS": 15,
        "iPhone 4": 20,
        "iPhone 4S": 25,
        "iPhone 5": 30,
        "iPhone 5C": 35,
        "iPhone 5S": 40,
        "iPhone 6": 45,
        "iPhone 6 Plus": 50,
        "iPhone6s": 55,
        "iPhone6s Plus": 60,
        "iPhoneSE": 65,
        "iPhone 7": 70,
        "iPhone 7 Plus": 75,
        "iPhone 8": 80,
        "iPhone 8 Plus": 85,
        "iPhone X": 90
    },
    bundleconfig: {
        "com.beeplayer.smart": { //appstore--玩派
            version: "1.0.1",
            sharecfg: "wpbeeplayshare", //分享
            relinkcfg: "wprelinkautotask", //断线重连
            fastentrycfg: "wpinstallfastentry", //入口安装
            opensafaricfg: "forceOpenInSafari", //在safari中打开
            isqiye: false, //是否企业包 
            needopensafari: true, //是否需要在safari打开的功能
            withdrawbywx: false //是否支持微信提现
        },

    }
}


// WEBPACK FOOTER //
// ./src/common/global.js